import styled from 'styled-components';
import { position, layout, space, border } from 'styled-system';
import { cursor } from '@magalu/stereo-ui-styles';
export const Image = styled.img`
  width: 100%;
  height: inherit;
  object-fit: ${({
  objectFit
}) => objectFit || 'contain'};
  ${position}
  ${space}
  ${layout}
  ${border}
  ${cursor}
`;